export const DATE_FORMATS = {
  // Full datetime format: "2024-01-15 14:30:25"
  DATETIME_FULL: 'YYYY-MM-DD HH:mm:ss',

  // Date only format: "2024-01-15"
  DATE_ONLY: 'YYYY-MM-DD',

  // Time only format: "14:30:25"
  TIME_ONLY: 'HH:mm:ss',

  // Short datetime format: "2024-01-15 14:30"
  DATETIME_SHORT: 'YYYY-MM-DD HH:mm',

  // Human readable format: "Jan 15, 2024 2:30 PM"
  HUMAN_READABLE: 'MMM dd, yyyy h:mm a',

  // ISO format: "2024-01-15T14:30:25.000Z"
  ISO: "YYYY-MM-DD'T'HH:mm:ss.SSS'Z'",

  // File name format: "2024-01-15_14-30-25"
  FILENAME: 'YYYY-MM-DD_HH-mm-ss',

  // Format: "2024-01-15-23"
  DATETIME_ONLY_HOURS: 'YYYY-MM-DD-HH',
};

// Default format for inbox send time
export const INBOX_SEND_TIME_FORMAT = DATE_FORMATS.DATETIME_FULL;

// Default format for general display
export const DEFAULT_DATETIME_FORMAT = DATE_FORMATS.DATETIME_FULL;

export default DATE_FORMATS;
